"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useTeamMessageTemplates = void 0;

var _reactRedux = require("react-redux");

var _react = require("react");

var _teamMessageTemplates = require("../store/entities/teamMessageTeamplates/teamMessageTemplates.selectors");

var _teamMessageTemplates2 = require("../store/entities/teamMessageTeamplates/teamMessageTemplates.actions");

var useAll = function useAll() {
  return (0, _reactRedux.useSelector)(_teamMessageTemplates.getTeamMessageTemplatesAll);
};

var useTeamMessageTemplates = function useTeamMessageTemplates(_ref) {
  var teamId = _ref.teamId,
      queryParams = _ref.queryParams;
  var dispatch = (0, _reactRedux.useDispatch)();
  var isIdle = (0, _reactRedux.useSelector)(_teamMessageTemplates.getIsTeamMessageTemplatesIdle);
  var isFulfilled = (0, _reactRedux.useSelector)(_teamMessageTemplates.getIsTeamMessageTemplatesFulfilled);
  var isPending = (0, _reactRedux.useSelector)(_teamMessageTemplates.getIsTeamMessageTemplatesPending);
  var storeTeamId = (0, _reactRedux.useSelector)(_teamMessageTemplates.getTeamMessageTemplatesTeamId);
  (0, _react.useEffect)(function () {
    if (teamId && (isIdle || teamId !== storeTeamId)) {
      dispatch((0, _teamMessageTemplates2.fetchMessageTemplatesByTeamId)({
        teamId,
        queryParams: queryParams || {}
      }));
    }
  }, [queryParams, teamId, isIdle, storeTeamId, dispatch]);
  return (0, _react.useMemo)(function () {
    return {
      isIdle,
      isFulfilled,
      isPending,
      useAll
    };
  }, [isIdle, isFulfilled, isPending]);
};

exports.useTeamMessageTemplates = useTeamMessageTemplates;